import { appSettings } from '../AppSettings';
import { BaseGet } from './BaseData';
import { StepCounts } from './SampleTrackingData';

export interface Step extends StepCounts {
  name: string;
}

export interface StepType {
  displayName: string;
  all: StepCounts;
  steps: Step[];
}

export interface ProjectStepTypes {
  researchProjectId: string;
  name: string;
  stepTypes: Record<string, StepType>;
}

export interface FulfillmentPlan {
  fulfillmentPlanId: string;
  name: string;
  description?: string;
  createdAt: string;
  updatedAt: string;
  sampleCount: number;
  stepTypes?: Record<string, StepType>;
  researchProjects?: ProjectStepTypes[];
}

const BASE_URL = `${appSettings.api.endpoint}/api/v2/FulfillmentPlans`;

export async function GetFulfillmentPlanCounts(accessToken: string): Promise<FulfillmentPlan[]> {
  const url = `${BASE_URL}/Counts`;

  return await BaseGet(url, accessToken);
}
